import { render } from "./LeaderBoard.vue?vue&type=template&id=739ebee0&scoped=true"
import script from "./LeaderBoard.vue?vue&type=script&lang=js"
export * from "./LeaderBoard.vue?vue&type=script&lang=js"

import "./LeaderBoard.vue?vue&type=style&index=0&id=739ebee0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739ebee0"]])

export default __exports__